import styled from "styled-components";
import { Icon} from "@virkesborsen/ui-component-library";

// Containers
export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
`

export const GrowingContainer = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
`

export const IconContainer = styled.div`
  margin-bottom: 0.75rem;
`;

export const StyledIcon = styled(Icon)`
  margin-bottom: 16px;
`;
